import React, { useCallback, useContext, useEffect, useState } from 'react';
import CurrentUserEnquiryContextContext from './CurrentUserEnquiryContext.context';
import api from 'api';
import { UserEnquiryContext } from 'models/UserEnquiryContext';
import useLoadingState from 'hooks/useLoadingState';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';

const CurrentUserEnquiryContext: React.FC = (props) => {
  const { children } = props;

  const {
    isLoading,
    isLoadingIds,
    getIsLoading,
    updateIsLoading,
    updateIsLoadingIds,
  } = useLoadingState(true);

  const [userEnquiryContext, setUserEnquiryContext] = useState<
    UserEnquiryContext[]
  >([]);

  const { popServerError } = useContext(PopNotificationsContext);

  const onNewEnquiryContext = useCallback(
    (newEnquiryContext: UserEnquiryContext) =>
      setUserEnquiryContext((prev) => [newEnquiryContext, ...prev]),
    [],
  );

  const onUpdateEnquiryContext = useCallback(
    (updatedEnquiryContext: UserEnquiryContext) =>
      setUserEnquiryContext((prev) =>
        prev.map((context) =>
          context._id === updatedEnquiryContext._id
            ? updatedEnquiryContext
            : context,
        ),
      ),
    [],
  );

  const onDeleteEnquiryContext = useCallback(
    async (enquiryContextId: string) => {
      try {
        updateIsLoadingIds(enquiryContextId);
        await api.enquiryContext.deleteEnquiryContext(enquiryContextId);
        setUserEnquiryContext((prev) =>
          prev.filter(({ _id }) => _id !== enquiryContextId),
        );
      } catch (e) {
        popServerError(e);
      } finally {
        updateIsLoadingIds(enquiryContextId, false);
      }
    },
    [popServerError, updateIsLoadingIds],
  );

  useEffect(() => {
    (async () => {
      try {
        updateIsLoading(true);
        const { data } = await api.enquiryContext.getEnquiryContexts();
        setUserEnquiryContext(data);
      } catch {
        return;
      } finally {
        updateIsLoading(false);
      }
    })();
  }, [updateIsLoading]);

  return (
    <CurrentUserEnquiryContextContext.Provider
      value={{
        isLoading,
        isLoadingIds,
        userEnquiryContext,
        getIsLoading,
        updateIsLoadingIds,
        onNewEnquiryContext,
        onUpdateEnquiryContext,
        onDeleteEnquiryContext,
      }}
    >
      {children}
    </CurrentUserEnquiryContextContext.Provider>
  );
};

export default CurrentUserEnquiryContext;
